import { UnorderedList, ListItem, Text } from '@chakra-ui/react';
import { RequirementsSummary } from 'shared-components';
import UploadIntro from '../../../../atoms/upload-intro';

interface IProps {
  uploadComplete: boolean;
  highlightedSections: string[];
}

export default function Requirements(props: IProps) {
  const allSections = ['1.1', '1.2', '1.3', '2.1', '2.2', '3.1', '3.2', '3.3', '3.4', '3.5', '4.1'];
  const sectionsToShow =
    props.highlightedSections && props.highlightedSections.length ? props.highlightedSections : allSections;

  return (
    <>
      {props.highlightedSections.length > 0 ? (
        <UploadIntro uploadWarning={true}>
          <>
            Your document <b>does not meet all requirements</b> therefore further action is required
          </>
        </UploadIntro>
      ) : (
        <Text>Please ensure your sponsor letter meets the following requirements.</Text>
      )}
      {sectionsToShow.join('').indexOf('1.') !== -1 ? (
        <RequirementsSummary
          uploadWarning={props.uploadComplete}
          title={'1. We have to be sure your letter is authentic'}
        >
          {sectionsToShow.includes('1.1') || sectionsToShow.includes('1.2') || sectionsToShow.includes('1.3') ? (
            <UnorderedList>
              {sectionsToShow.includes('1.1') ? (
                <ListItem>
                  Your letter printed on official letter headed paper or stationary of the sponsoring organisation
                </ListItem>
              ) : null}
              {sectionsToShow.includes('1.2') ? (
                <ListItem>The letterhead must include the name and logo of the sponsor</ListItem>
              ) : null}
              {sectionsToShow.includes('1.3') ? (
                <ListItem>
                  The letter should include a signature and/or the official stamp or seal of the sponsor{' '}
                </ListItem>
              ) : null}
            </UnorderedList>
          ) : null}
        </RequirementsSummary>
      ) : null}

      {sectionsToShow.join('').indexOf('2.') !== -1 ? (
        <RequirementsSummary uploadWarning={props.uploadComplete} title={'2. Your letter must have a valid date'}>
          <UnorderedList>
            {sectionsToShow.includes('2.1') ? <ListItem>The date must be no more than 31 days ago</ListItem> : null}
            {sectionsToShow.includes('2.2') ? (
              <ListItem>
                It is recommended that the date gives you enough time to use it for your visa application (optional){' '}
              </ListItem>
            ) : null}
          </UnorderedList>
        </RequirementsSummary>
      ) : null}

      {sectionsToShow.join('').indexOf('3.') !== -1 ? (
        <RequirementsSummary
          uploadWarning={props.uploadComplete}
          title={'3. The body text of the letter must state the intention and details of your loan provider'}
        >
          <UnorderedList>
            {sectionsToShow.includes('3.1') ? (
              <ListItem>
                The letter must specify your name to identify you as the recipient of the funds (matching passport)
              </ListItem>
            ) : null}
            {sectionsToShow.includes('3.2') ? (
              <ListItem>The name of the sponsoring organisation must be confirmed as the source of funds</ListItem>
            ) : null}
            {sectionsToShow.includes('3.3') ? (
              <ListItem>The name of the course as per your offer letter must be specified</ListItem>
            ) : null}
            {sectionsToShow.includes('3.4') ? (
              <ListItem>
                The amount in pounds or the percentage being covered or a statement that confirms that ALL living costs
                and fees are covered
              </ListItem>
            ) : null}
            {sectionsToShow.includes('3.5') ? (
              <ListItem>
                The period the sponsorship will be covering you for (should match your course start and end date)
              </ListItem>
            ) : null}
          </UnorderedList>
        </RequirementsSummary>
      ) : null}

      {sectionsToShow.join('').indexOf('4.') !== -1 ? (
        <RequirementsSummary
          uploadWarning={props.uploadComplete}
          title={'4. We may need to contact your loan provider'}
        >
          <UnorderedList>
            {sectionsToShow.includes('4.1') ? (
              <ListItem>
                Please ensure contact details are included in the letterhead or the body of the letter{' '}
              </ListItem>
            ) : null}
          </UnorderedList>
        </RequirementsSummary>
      ) : null}
    </>
  );
}
